var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" Search Route List "),_c('div',[_c('b-button',{staticClass:"is-success"},[_vm._v("Search without time limited")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }